import classnames from 'classnames/bind'
import React, { ReactNode } from 'react'

import Cta, { CtaProps } from '~/components/Cta'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface HeroEditoProps {
  className?: string
  children?: ReactNode | ReactNode[]
  title?: RichTextBlock[]
  text?: RichTextBlock[]
  subtext?: RichTextBlock[]
  primaryCta?: CtaProps
  secondaryCta?: CtaProps
}

function HeroEdito({
  className,
  title,
  text,
  subtext,
  children,
  primaryCta,
  secondaryCta,
}: HeroEditoProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const titleStyle = useStyle({ textPreset: 'title-section-page' })
  const textStyle = useStyle({
    textPreset: 'title-content-section',
    color: 'blue-bayoux',
  })
  const subtextStyle = useStyle({
    textPreset: 'title-paragraph-content',
    color: 'blue-bayoux',
  })

  return (
    <div className={cx(css.HeroEdito, className)}>
      <div className={cx(css.header, gridStyle)}>
        {text && <RichText className={cx(textStyle, css.text)} render={text} />}

        {title && (
          <RichText className={cx(titleStyle, css.title)} render={title} />
        )}

        {subtext && (
          <RichText
            className={cx(subtextStyle, css.subtext)}
            render={subtext}
          />
        )}

        <div className={cx(css.ctas)}>
          {primaryCta && <Cta className={css.cta} {...primaryCta} />}
          {secondaryCta && <Cta className={css.cta} {...secondaryCta} />}
        </div>

        {children}
      </div>
    </div>
  )
}

HeroEdito.defaultProps = {}

export default HeroEdito
